import {get} from "svelte/store"
import {sessionData} from "../../stores.js"
import {consoleMessageTopics} from "../../../lib/chess-console/ChessConsole.js"
import {_} from 'svelte-i18n'

/**
 * Author: Stefan Haack (https://shaack.com)
 */

const endOfGameDescriptionsReverseLookup = {
  "won by checkmate": "wonByCheckmate",
  "lost on time": "lostOnTime",
  "resigns": "resigns",
  "game drawn by agreement": "gameDrawnByAgreement",
  "abandoned the game": "abandonedTheGame",
  "game aborted": "gameAborted",
  "game drawn by stalemate": "gameDrawnByStalemate",
  "game drawn by 50-move rule": "gameDrawnByFiftyMoveRule",
  "game drawn by insufficient material": "gameDrawnByInsufficientMaterial",
  "game drawn by threefold repetition": "gameDrawnByThreefoldRepetition",
};


const getColorFromEndOfGameMessage = (msg) => {
  if (msg.startsWith("white") || msg.startsWith(" white")){
    return "white"
  } else if (msg.startsWith("black") || msg.startsWith(" black")){
    return "black"
  } else {
    return null

  }

}

function getEndOfGameMessage(gameState){

  const msg = gameState._outcome._endOfGameMessage
  const isDeterminate = msg.startsWith("white") || msg.startsWith("black") || msg.startsWith(" white") || msg.startsWith(" black")
  const i18n = get(_)
  if (isDeterminate){
    const desc = endOfGameDescriptionsReverseLookup[msg.split(' ').slice(1).join(' ')]
    const color = getColorFromEndOfGameMessage(msg)
    return (i18n(`endOfGame.${color}`) + " " + i18n(`endOfGame.${desc}`))
  } else {
    const descr = endOfGameDescriptionsReverseLookup[msg]
    return i18n(`endOfGame.${descr}`)
  }


}





export class EndOfGameActions {

    constructor(app) {
        this.app = app
        this.app.state.addObserver(() => {
            this.redraw()
        }, ['gameState'])
    }

    redraw() {
        const gameState = this.app.state.gameState
        const sessionDataValue = get(sessionData)
        const chessConsole = this.app.components.chessConsole
        const i18n = get(_)
        if(gameState._outcome) {
            sessionDataValue.endOfGame = true
            //sessionDataValue.endOfGameMessage = gameState._outcome._endOfGameMessage
            sessionDataValue.endOfGameMessage = getEndOfGameMessage(gameState)
            if(!sessionDataValue.resultForPlayer) {
                if (gameState._outcome._endOfGameMessage == "game aborted"){
                    sessionDataValue.resultForPlayer = i18n("endOfGame.aborted")
                    chessConsole.messageBroker.publish(consoleMessageTopics.drawOutcome)
                }
                if(gameState._outcome._isDraw && gameState._outcome._endOfGameMessage != "game aborted") {
                    sessionDataValue.resultForPlayer = i18n("endOfGame.draw")
                    chessConsole.messageBroker.publish(consoleMessageTopics.drawOutcome)
                } else if(gameState._outcome._winnerUID === this.app.props.playerUid) {
                    sessionDataValue.resultForPlayer = i18n("endOfGame.victory")
                    chessConsole.messageBroker.publish(consoleMessageTopics.victoryOutcome)
                } else if(gameState._outcome._loserUID === this.app.props.playerUid) {
                    sessionDataValue.resultForPlayer = i18n("endOfGame.defeat")
                    chessConsole.messageBroker.publish(consoleMessageTopics.defeatOutcome)
                }
            }
            sessionDataValue.ratingBefore = gameState._outcome._user.old_elo
            sessionDataValue.ratingDiff = gameState._outcome._user.elo_delta
            sessionDataValue.ratingAfter = gameState._outcome._user.elo
            sessionDataValue.balanceBefore = gameState._outcome._user.old_balance
            sessionDataValue.balanceDiff = gameState._outcome._user.balance_delta
            sessionDataValue.balanceAfter = gameState._outcome._user.balance
            if(gameState._outcome._rematchState._opp_rematch && gameState._outcome._rematchState._opp_online) {
                sessionDataValue.showAcceptRematchDialog = true
                chessConsole.messageBroker.publish(consoleMessageTopics.rematchOffer)
            } else {
                sessionDataValue.showAcceptRematchDialog = false
            }
        } else {
            sessionDataValue.endOfGame = false
            sessionDataValue.showAcceptRematchDialog = false
        }
        sessionData.set(sessionDataValue)
    }
}
